module.exports = __webpack_public_path__ + "img/954ed89.png";